module.exports = __webpack_public_path__ + "asset/image-Laptop-8c7762aeb2c771ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Laptop.svg
// module id = /KNH
// module chunks = 0